const headersEndpointsAgendamento = {
  'x-origin-application': 'agendamento-consulta-frontend',
  'x-origin-channel': 'frontend'
}

export default headersEndpointsAgendamento
